import ResizeObserver from 'resize-observer-polyfill'

let resizeObserver = null

/**
 * 元素尺寸变化指令，通过自定义事件触发
 */
export default {
  mounted(el) {
    if (!resizeObserver) {
      resizeObserver = new ResizeObserver((entries) => {
        for (let i = 0, len = entries.length; i < len; i++) {
          const entry = entries[i]
          const { target } = entry
          // 通过dom自定义事件触发
          const event = new CustomEvent('resize', {
            detail: entry.contentRect
          })
          target.dispatchEvent(event)
        }
      })
    }
    resizeObserver.observe(el)
  },
  beforeUnmount(el) {
    if (resizeObserver) {
      resizeObserver.unobserve(el)
    }
  }
}
